import jzbApiList from '@/service/basic/jzbApiList'
import service from '@/service/jzb_api'
/*
  2021-11-03 将原来见证宝的接口 拆分成 两部分
  服务域名 myhostname test.nagy.ruigushop.com
  接口前缀 一部分 finance_jigsaw 一部分保持原来 finance_jigsaw_jzb
*/
const host = myhostname;
const finance_jigsaw = '/finance-jigsaw';
const finance_jigsaw_jzb = '/finance-jigsaw-jzb';

/*
  * @export 2021 11 04
  * @param {*} params
  * @returns Prmoise
  * @description 判断 是否开通见证宝 并且判断 开通的是对公的 还是对私的账号
*/
export function jzbFlag (params) {
  return new Promise((resolve, reject) => {
    service.get(host + finance_jigsaw + jzbApiList.jzb_flag, {
      params
    }).then(res => {
        resolve(res)
    }).catch(err => {
        reject(err)
    })
  })
}

/*
  * @export 2021 11 05
  * @param {*} params
  * @returns Prmoise
  * @description 公司下拉列表
*/
export function jzbCropList (params) {
  return new Promise((resolve, reject) => {
    service.get(host + finance_jigsaw + jzbApiList.jzb_cropList, {
      params
    }).then(res => {
        resolve(res)
    }).catch(err => {
        reject(err)
    })
  })
}

/**
 * @export
 * @param {*} params
 * @returns Prmoise
 * @description 查询账户信息是否绑定
 */
export function jzbReqAcc (params) {
  return new Promise((resolve, reject) => {
    service({
      url: host + finance_jigsaw + jzbApiList.jzb_accInfo,
      method: 'post',
      data: params
    })
      .then(function (res) {
        resolve(res)
      })
      .catch(function (err) {
        reject(err)
        console.log(err)
      })
  })
}
/**
 * @export
 * @param {*} params
 * @returns Prmoise
 * @description 查询总行
 */
export function jzbReqBankHead (params) {
  return service({
    url: host + finance_jigsaw_jzb + jzbApiList.jzb_Bank,
    method: 'post',
    data: params
  })
}

/**
 * @export
 * @param {*} params
 * @returns Prmoise
 * @description 查询支行
 */
export function jzbReqBankTree (params) {
  return service({
    url: host + finance_jigsaw_jzb + jzbApiList.jzb_BankTree,
    method: 'get',
    params: params
  })
}
/**
 * @export
 * @param {*} params
 * @returns Prmoise
 * @description 查询证件类型
 */
export function jzbReqCardType (params) {
  return service({
    url: host + finance_jigsaw_jzb + jzbApiList.jzb_cardType,
    method: 'post',
    data: params
  })
}
/**
 * @export
 * @param {*} params
 * @returns Prmoise
 * @description 个人鉴权 发送验证码
 */
export function jzbPersonSendCode (params) {
  return service({
    url: host + finance_jigsaw + jzbApiList.jzb_personCode,
    method: 'post',
    data: params
  })
}
/**
 * @export
 * @param {*} params
 * @returns Prmoise
 * @description 个人鉴权 验证验证码并绑定
 */
export function jzbPersonBind (params) {
  return service({
    url: host + finance_jigsaw + jzbApiList.jzb_personBind,
    method: 'post',
    data: params
  })
}
/**
 * @export
 * @param {*} params
 * @returns Prmoise
 * @description 企业鉴权 发送验证金额
 */
export function jzbBusinessSendCode (params) {
  return service({
    url: host + finance_jigsaw + jzbApiList.jzb_businessCode,
    method: 'post',
    data: params
  })
}
// /**
//  * @export
//  * @param {*} params
//  * @returns Prmoise
//  * @description 企业鉴权 验证结果
//  */
// export function jzbBusinessBindResult (params) {
//   return service({
//     url: jzbApiList.jzb_businessCodeResult,
//     method: 'post',
//     data: params
//   })
// }
/**
 * @export
 * @param {*} params
 * @returns Prmoise
 * @description 企业绑定
 */
export function jzbBusinessBind (params) {
  return service({
    url: host + finance_jigsaw + jzbApiList.jzb_businessBind,
    method: 'post',
    data: params
  })
}
/**
 * @export
 * @param {*} params
 * @returns Prmoise
 * @description 提现验证码
 */
export function jzbCashCode (params) {
  return service({
    url: host + finance_jigsaw + jzbApiList.jzb_cashCode,
    method: 'post',
    data: params
  })
}
/**
 * @export
 * @param {*} params
 * @returns Prmoise
 * @description 提现
 */
export function jzbCashFee (params) {
  return service({
    url: host + finance_jigsaw + jzbApiList.jzb_cashFee,
    method: 'post',
    data: params
  })
}
/**
 * @export
 * @param {*} params
 * @returns Prmoise
 * @description 提现
 */
export function jzbCashInfo (params) {
  return service({
    url: host + finance_jigsaw + jzbApiList.jzb_cashInfo,
    method: 'post',
    data: params
  })
}
/**
 * @export
 * @param {*} params
 * @returns Prmoise
 * @description 提现
 */
export function jzbUnbind (params) {
  return service({
    url: host + finance_jigsaw + jzbApiList.jzb_unbind,
    method: 'post',
    data: params
  })
}
/**
 * @export
 * @param {*} params
 * @returns Prmoise
 * @description 提现列表
 */
export function jzbCashList (params) {
  return service({
    url: host + finance_jigsaw + jzbApiList.jzb_cashList,
    method: 'post',
    data: params
  })
}
/**
 * @export
 * @param {*} params
 * @returns Prmoise
 * @description 交易明细
 */
export function jzbTransDetail (params) {
  return service({
    url: host + finance_jigsaw_jzb + jzbApiList.jzb_transferDetail,
    method: 'post',
    data: params
  })
}
/**
 * @export
 * @param {*} params
 * @returns Prmoise
 * @description 交易明细
 */
export function jzbTransferDetailInfo (params) {
  return service({
    url: host + finance_jigsaw_jzb + jzbApiList.jzb_transferDetailInfo + params,
    method: 'get'
  })
}
/**
 * @export
 * @param {*} params
 * @returns Prmoise 交易明细导出 新增字段 corpId
 */
export function jzbTransDetailExport (params) {
  // eslint-disable-next-line
  return host + finance_jigsaw_jzb + jzbApiList.jzb_transferDetailExport + `?objectType=${params.objectType}&shopId=${params.shopId}&corpId=${params.corpId}&operationType=${params.operationType}&createdStartOn=${params.createdStartOn}&createdEndOn=${params.createdEndOn}&access_token=ashdihasuahduisa73222222e3ref22f32ff223223f`
}
/**
 * @export
 * @param {*} params
 * @returns Prmoise
 */
export function jzbExportPayShopDepositLog (params) {
  // eslint-disable-next-line
  return host + finance_jigsaw_jzb +  + jzbApiList.jzb_exportPayShopDepositLog + `?shopId=${params.shopId}&operationType=${params.operationType}&startDate=${params.startDate}&endDate=${params.endDate}&access_token=ashdihasuahduisa73222222e3ref22f32ff223223f`
}
/**
 * @export
 * @param {*} params
 * @returns Prmoise
 *
 */
export function jzbQeryPayShopDepositLog (params) {
  return service({
    url: host + finance_jigsaw_jzb + jzbApiList.jzb_queryPayShopDepositLog,
    data: params,
    method: 'post'
  })
}

/**
 * @export
 * @param {*} params
 * @returns Prmoise
 * @description 见证宝-公告-条件查询
 */
export function jzbQueryNotice (params) {
  return service({
    url: host + finance_jigsaw_jzb + jzbApiList.jzb_queryNotice,
    params: params,
    method: 'get'
  })
}
/**
 * @export
 * @param {*} params
 * @returns Prmoise
 * @description 查询省级信息
 */
export function jzbProvinceList (params) {
  return service({
    url: host + finance_jigsaw_jzb + jzbApiList.jzb_provinceList,
    params: params,
    method: 'get'
  })
}
/**
 * @export
 * @param {*} params
 * @returns Prmoise
 * @description 查询市级信息
 */
export function jzbCityList (code) {
  return service({
    url: host + finance_jigsaw_jzb + jzbApiList.jzb_cityList + code,
    method: 'get'
  })
}
/**
 * @export
 * @param {*} params
 * @returns Prmoise
 * @description 查询补录信息
 */
export function jzbBankAdditionalRecorded (data) {
  return service({
    url: host + finance_jigsaw_jzb + `/witness/legal-person-information/${data}/bank-additional-recorded`,
    data: {},
    method: 'get'
  })
}
/**
 * @export
 * @param {*} params
 * @returns Prmoise
 * @description 获取补录地址
 */
export function jzbSupplementaryUrl (params) {
  return service({
    url: host + finance_jigsaw_jzb + jzbApiList.jzb_supplementaryUrl,
    params: params,
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/models/jzbModel.js